import * as R from 'rambdax'
import {useState} from 'react'
import {logger, meta} from 'tizra'
import * as B from '../block'
import {Admin} from './admin'
import {Complex} from './Complex'
import {meta as metadata} from './meta'
import {Simple} from './Simple'

const log = logger('ImageBlock')

export const ImageBlock = B.blockWithInfo(
  {...metadata, Admin, dividers: false},
  ({
    config: {
      tizraId: imageId,
      imageUrl,
      coverId,
      altText,
      linkUrl,
      width,
      fitting,
      focus,
      maxHeight,
      maxWidth,
      position,
      surround,
    },
  }) => {
    // Simplify incoming config.
    const isCover = imageId === '_cover'
    imageId = isCover ? '' : imageId
    coverId = isCover ? coverId : ''

    // Maybe load a cover image.
    const context = B.useBlockContext()
    const coverObj = B.useMetaObj({
      enabled: isCover,
      ...(coverId ?
        {tizraId: coverId}
      : R.pick(['metaType', 'tizraId'], context)),
      options: {alertOnError: false},
    })
    const fallbackHack = B.useHack('coverFallback')
    const [{data: oEmbed}, visRef] = B.useOEmbed({metaObj: coverObj})

    // Maybe load an image object.
    const imageObj = B.useMetaObj({
      enabled: !isCover,
      tizraId: imageId,
      options: {alertOnError: false},
    })

    if (imageId) {
      imageUrl = `/${imageId}/~stream`
      altText = meta.string(imageObj, 'Description') || ''
    } else if (isCover) {
      imageUrl = meta.coverImage(coverObj, {fallbackHack, oEmbed}) || ''
      altText = meta.name(coverObj) || ''
    }

    const [errored, setErrored] = useState<string>()

    if (!imageUrl || errored === imageUrl) {
      return null
    }

    const image =
      maxWidth || maxHeight || fitting === 'scale-down' ?
        <Complex
          imageUrl={imageUrl}
          altText={altText}
          linkUrl={linkUrl}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          fitting={fitting}
          position={position}
          focus={focus}
          surround={surround}
          setErrored={setErrored}
        />
      : <Simple
          imageUrl={imageUrl}
          altText={altText}
          linkUrl={linkUrl}
          surround={surround}
          setErrored={setErrored}
        />

    return (
      <B.Section
        bleed={width === 'bleed'}
        variant={surround === 'none' ? 'abutting' : 'skinny'}
        ref={visRef}
        {...B.tid('ImageBlock-section')}
      >
        {image}
      </B.Section>
    )
  },
)
